/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Go_To_Event_StartInputs */



/**
* | output |
* | --- |
* | "Update playhead to the start of the selected event" |
*
* @param {Shortcut_Keys_Desc_Go_To_Event_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_go_to_event_start = /** @type {((inputs?: Shortcut_Keys_Desc_Go_To_Event_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Go_To_Event_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre la tete de lecture au debut de l'evenement selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiere den Abspielkopf an den Anfang des ausgewählten Ereignisses")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna la testina di riproduzione all'inizio dell'evento selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместите ползунок воспроизведения к началу выбранного события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar el cabezal de reproducción al inicio del evento seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将播放头更新到所选事件的开头")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントの開始位置に再生ヘッドを更新します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेहेड को चयनित इवेंट की शुरुआत में अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualize o indicador de reprodução para o início do evento selecionado.")
	return /** @type {LocalizedString} */ ("Update playhead to the start of the selected event")
});